import React, { useEffect, useState } from 'react';
import axios from 'axios';

interface Product {
  id: number;
  name: string;
}

const UploadProductImages: React.FC = () => {
  const [productId, setProductId] = useState('');
  const [products, setProducts] = useState<Product[]>([]);
  const [images, setImages] = useState<FileList | null>(null);

  useEffect(() => {
    axios
      .get<Product[]>('http://localhost:3001/api/products')
      .then((res) => setProducts(res.data))
      .catch((err) => {
        console.error('Failed to fetch products:', err);
        alert('Error loading products');
      });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!images || images.length === 0) {
      alert('Please select up to 3 images.');
      return;
    }

    if (images.length > 3) {
      alert('You can only upload a maximum of 3 images.');
      return;
    }

    const formData = new FormData();
    formData.append('productId', productId);
    for (let i = 0; i < images.length; i++) {
      formData.append('images', images[i]);
    }

    try {
      const res = await axios.post('http://localhost:3001/api/product-images', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (res.status === 201) {
        alert('Images uploaded successfully!');
        setProductId('');
        setImages(null);
        (document.getElementById('fileInput') as HTMLInputElement).value = '';
      }
    } catch (err) {
      console.error('Error uploading images:', err);
      alert('Failed to upload images');
    }
  };

  return (
    <div>
      <h2>Upload Product Images (Max 3)</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Select Product:</label><br />
          <select
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            required
          >
            <option value="">-- Select Product --</option>
            {products.map((product) => (
              <option key={product.id} value={product.id}>{product.name}</option>
            ))}
          </select>
        </div>

        <div>
          <label>Choose Images (Max 3):</label><br />
          <input
            type="file"
            id="fileInput"
            accept="image/*"
            multiple
            onChange={(e) => setImages(e.target.files)}
            required
          />
        </div>

        <button type="submit">Upload</button>
      </form>
    </div>
  );
};

export default UploadProductImages;
